import { Text } from '@/components/ui/text'
import { AppTooltip } from '@components/AppTooltip'
import type { Tables } from '@hvf/contracts'
import { Ruler, TrendingUp } from 'lucide-solid'
import { Show } from 'solid-js'
import { css } from 'styled-system/css'
import { Box, Flex } from 'styled-system/jsx'
import { promptTooltipClass } from '../routes/Setups/promptTooltipClass'

const noShrink = css({ flexShrink: 0 })

export default function (props: { setup?: Tables<'setup'>, textStyle?: string, size?: string }) {
  const dim = props.size || '24px'
  const radius = props.size ? '7px' : '8px'
  const iconSize = props.size ? 14 : 13

  return (
    <Flex gap='6px'>
      <Show when={props.setup?.first_in_new_trend}>
        <AppTooltip
          delay={900}
          content="Potential Overperformance"
          contentClass={promptTooltipClass}
          className={noShrink}
        >
          <Box display='flex'
            alignItems='center'
            justifyContent='center'
            flexShrink={0}
            color='editorialAccentDeep'
            style={{
              width: dim,
              height: dim,
              'min-width': dim,
              'min-height': dim,
              'border-radius': radius,
              background: 'color-mix(in srgb, var(--colors-editorial-accent-deep) 8%, transparent)',
              border: '1.5px solid var(--colors-editorial-accent-deep)',
            }}
          >
            <TrendingUp size={iconSize} stroke='var(--colors-editorial-accent-deep)' />
          </Box>
        </AppTooltip>
      </Show>
      <Show when={props.setup?.has_primer}>
        <AppTooltip
          delay={900}
          content="Primer present"
          contentClass={promptTooltipClass}
          className={noShrink}
        >
          <Box display='flex'
            alignItems='center'
            justifyContent='center'
            flexShrink={0}
            color='editorialPrimer'
            style={{
              width: dim,
              height: dim,
              'min-width': dim,
              'min-height': dim,
              'border-radius': radius,
              background: 'color-mix(in srgb, var(--colors-editorial-primer) 8%, transparent)',
              border: '1.5px solid var(--colors-editorial-primer)',
            }}
          >
            <Text
              fontSize={props.size ? '12px' : 'sm'}
              fontWeight={props.size ? '800' : 'bold'}
            >
              P
            </Text>
          </Box>
        </AppTooltip>
      </Show>
      <Show when={props.setup?.scan_tool_valid}>
        <AppTooltip
          delay={900}
          content="Created with Date Extractor"
          contentClass={promptTooltipClass}
          className={noShrink}
        >
          <Box display='flex'
            alignItems='center'
            justifyContent='center'
            flexShrink={0}
            color='editorialInk3'
            style={{
              width: dim,
              height: dim,
              'min-width': dim,
              'min-height': dim,
              'border-radius': radius,
              background: 'color-mix(in srgb, var(--colors-editorial-ink3) 8%, transparent)',
              border: '1.5px solid var(--colors-editorial-ink3)',
            }}
          >
            <Ruler size={iconSize} stroke='var(--colors-editorial-ink3)' />
          </Box>
        </AppTooltip>
      </Show>
    </Flex>
  )
}
